// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"126":"8dffad1b","440":"adbc1028","581":"07b5e188"}[chunkId] + ".chunk.js";
};